import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

document.addEventListener('DOMContentLoaded', function() {
  createChat({
    webhookUrl: 'https://ai.eventya.net/webhook/5d68d87f-9037-4875-8a3b-a30131e5d650/chat',
    showWelcomeScreen: false,
    target: '#chatbot',
    defaultLanguage: 'ro',
    loadPreviousSession: false,
    initialMessages: [
      'Salutare 👋, cu ce te pot ajuta?'
    ],
    i18n: {
      ro: {
        title: 'Chatbot',
        subtitle: "Cu ce te pot ajuta?",
        getStarted: 'Incepe',
        inputPlaceholder: 'Scrie un mesaj...',
      },
    },
  });
});